var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header layout justify-space-between"},[_c('Logo',{attrs:{"url":require('../../../../public/images/' + _vm.logo),"classes_added":'header__logo'}}),(_vm.menuVisible)?_c('NavMenu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }